var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataUploadUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud_upload",
    clipPath: "url(#clip0_6681_29010)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.25 16.7332C31.1167 10.9832 26.0667 6.6665 20 6.6665C15.1833 6.6665 11 9.39984 8.91667 13.3998C3.9 13.9332 0 18.1832 0 23.3332C0 28.8498 4.48333 33.3332 10 33.3332H31.6667C36.2667 33.3332 40 29.5998 40 24.9998C40 20.5998 36.5833 17.0332 32.25 16.7332ZM31.6667 29.9998H10C6.31667 29.9998 3.33333 27.0165 3.33333 23.3332C3.33333 19.9165 5.88333 17.0665 9.26667 16.7165L11.05 16.5332L11.8833 14.9498C13.4667 11.8998 16.5667 9.99984 20 9.99984C24.3667 9.99984 28.1333 13.0998 28.9833 17.3832L29.4833 19.8832L32.0333 20.0665C34.6333 20.2332 36.6667 22.4165 36.6667 24.9998C36.6667 27.7498 34.4167 29.9998 31.6667 29.9998ZM13.3333 21.6665H17.5833V26.6665H22.4167V21.6665H26.6667L20 14.9998L13.3333 21.6665Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6681_29010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataUploadUploadIcon);
export default __webpack_public_path__ + "static/media/data-upload-upload-icon.9184deb15bef1b9a9dac2cd87dc32080.svg";
export { ForwardRef as ReactComponent };